/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpIcon16Regular = forwardRef('ArrowShapeAUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.587 1.603a2 2 0 0 1 2.828 0l5.689 5.69c.63.63.183 1.707-.707 1.707H12v4.25A1.75 1.75 0 0 1 10.25 15h-4.5A1.75 1.75 0 0 1 4 13.25V9H1.604C.713 9 .266 7.923.897 7.293l5.69-5.69Zm1.767 1.061a.5.5 0 0 0-.707 0L2.811 7.5H4.75a.75.75 0 0 1 .75.75v5c0 .138.112.25.25.25h4.5a.25.25 0 0 0 .25-.25v-5a.75.75 0 0 1 .75-.75h1.94L8.354 2.664Z" })));
});
